var option_default = {
  "option": "EOUWT",
  "user_choice": "o300r",
  "check": "Lwly5",
  "image": "dzdpz",
  "input": "hehh7",
  "title": "g6igk",
  "centered": "kEbfs",
  "with_result": "QLsmB",
  "list": "AgY9D",
  "with_image": "S-Lac",
  "progress": "_9C8fC",
  "progress_value": "vCleU",
  "label": "mK-tk",
  "cta": "LqB8N",
  "adornment_icon": "n-Nky",
  "remove": "WDKzH",
  "removeButton": "tbX8Y",
  "removeButtonIcon": "mA7yq",
  "overlay": "-AfiG",
  "shown": "KAMJW",
  "dark": "Kzju4",
  "spinner": "HH8qt",
  "spin": "jyGaV"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
